import React from 'react';
import { useLocation } from 'react-router';

function useParam(name) {
  const { search } = useLocation();
  const params = React.useMemo(() => new URLSearchParams(search), [search]);
  return params.get(name);
}
export default useParam;
